import { render, staticRenderFns } from "./NoteEditor.vue?vue&type=template&id=a6604df4&scoped=true&"
import script from "./NoteEditor.vue?vue&type=script&lang=js&"
export * from "./NoteEditor.vue?vue&type=script&lang=js&"
import style0 from "./NoteEditor.vue?vue&type=style&index=0&id=a6604df4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6604df4",
  null
  
)

export default component.exports